<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head
        :searchConfig="tableData.searchConfig"
        @searchData="searchData"
        @message="message"
        @deletePost="deletePost"
      />
    </template>
    <template>
      <Body
        ref="table"
        :headConfig="tableData.headConfig"
        :tableData="data.sendList"
        @deleteData="deleteDate"
        @select-change="selectChange"
        @sort-change="sortChange"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import getSendPage from "@/api/getSendPage.js";
import batchMessage from "@/api/batchMessage.js";
import batchDeleteSendQueue from "@/api/batchDeleteSendQueue.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";

export default {
  mixins: [requstData({ sendList: [], total: 10 })],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: true,
          selectProp: "createTime",
          key: "id",
          list: [
            { label: "详情", width: "65", type: "expand" },
            { label: "专页名称", prop: "pageName", width: "150" },
            { label: "贴文信息", prop: "content" },
            { label: "留言信息", prop: "leaveMessage" },
            { label: "类型", prop: "sendType", width: "80" },
            {
              label: "排文时间",
              prop: "sendTime",
              width: "180",
              sortable: "custom",
            },
            { label: "创建者", prop: "userName", width: "180" },
            {
              label: "创建时间",
              prop: "createTime",
              width: "180",
              sortable: "custom",
            },
            {
              label: "操作",
              width: "200",
              operation: [
                {
                  type: 1,
                  label: "删除",
                  style: "danger",
                  listeners: "deleteData",
                  confirm: "确定删除？",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            { type: "date", model: "date", span: 5 },
            {
              type: "input",
              model: "content",
              span: 3,
              placeholder: "请输入贴文内容",
            },
            {
              type: "input",
              model: "link",
              span: 3,
              placeholder: "请输入链接",
            },
            {
              type: "input",
              model: "pageName",
              span: 3,
              placeholder: "请输入专业名称",
            },
            {
              type: "input",
              model: "userName",
              span: 3,
              placeholder: "请输入创建者账号",
            },
            {
              type: "select",
              model: "sendType",
              span: 2,
              placeholder: "类型",
              setting: {
                multiple: true,
              },
              options: [
                { label: "链接", value: 1 },
                { label: "图片", value: 2 },
              ],
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "筛选",
                  style: "primary",
                  listeners: "searchData",
                },
                {
                  type: 2,
                  label: "批量删除",
                  style: "danger",
                  listeners: "deletePost",
                },
                //    {
                //     type: 2,
                //     label: "批量留言",
                //     style: "success",
                //     listeners: "message"
                // }
              ],
            },
          ],
        },
      },
    };
  },
  created() {},
  methods: {
    async requst(params) {
      if (this.$refs.table) {
        this.$refs.table.resetSort();
      }
      return await getSendPage({ ...params, ...{ type: 1 } });
    },
    async deleteDate(data) {
      this.isLoading = true;
      let res = await batchDeleteSendQueue(new Array(1).fill(data.id));
      this.isLoading = false;
      if (res === "ok") {
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功",
        });
        this.getData();
      }
    },
    deletePost(data) {
      if (this.selection.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择贴文",
          type: "error",
        });
        return;
      }
      this.$confirm("此操作将删除选择的贴文, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "删除中...";
            let res = await batchDeleteSendQueue(this.selection);
            if (res === "ok") {
              done();
              this.getData();
            }
            instance.confirmButtonLoading = false;
          } else {
            done();
          }
        },
      }).then(() => {
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功!",
        });
      });
    },
    message(data) {
      if (this.selection.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择贴文",
          type: "error",
        });
        return;
      }
      this.$prompt("请输入留言", "批量留言", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputPattern: /^\s*\S+[\s\S]*$/,
        inputErrorMessage: "留言不得为空",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "提交中...";
            let res = await batchMessage({
              ids: this.selection,
              note: instance.inputValue,
            });
            if (res === "ok") {
              done();
              this.getData();
            }
            instance.confirmButtonLoading = false;
          } else {
            done();
          }
        },
      }).then(({ value }) => {
        this.$message({
          showClose: true,
          type: "success",
          message: "留言成功",
        });
      });
    },
  },
};
</script>
